import { Banner } from '@/components/ui/banner'

interface ClaimPhotoExtractionBannerProps {
  /** The uploads are still being read. */
  reading: boolean
  /** Something on this step was filled in from them. */
  filled: boolean
}

export function ClaimPhotoExtractionBanner({ reading, filled }: ClaimPhotoExtractionBannerProps) {
  if (reading) {
    return (
      <Banner variant="info" small>
        We&apos;re reading your photos and documents. Anything we find fills in below — keep going.
      </Banner>
    )
  }
  if (filled) {
    return (
      <Banner variant="info" small>
        We filled in some of this from your photos and documents. Check it before you continue.
      </Banner>
    )
  }
  return null
}
